import { Component, OnInit } from '@angular/core';
import { GlossVotesDonutComponent } from "./gloss-votes-donut/gloss-votes-donut.component";
import { MatCardModule } from '@angular/material/card';
import { ActivatedRoute } from '@angular/router';
import { ProjectConfiguration, ProjectId } from '@models/ProjectConfiguration';
import { SynchronizerService } from '../synchronizer.service';
import { combineLatest } from 'rxjs';
import { BookIdentifier } from '@models/BookIdentifier';

@Component({
  selector: 'app-stats',
  imports: [
    MatCardModule,
    GlossVotesDonutComponent
  ],
  templateUrl: './stats.component.html',
  styleUrl: './stats.component.scss'
})
export class StatsComponent implements OnInit {
  project: ProjectConfiguration | undefined;
  header: string = '';
  bid: BookIdentifier | undefined;

  constructor(
    private route: ActivatedRoute,
    private synchronizerService: SynchronizerService
  ) {
  }

  ngOnInit(): void {
    combineLatest([this.route.paramMap, this.synchronizerService.user$]).subscribe(([params, user]) => {
      const id = params.get('projectid') as ProjectId;
      const p = user?.project(id);
      if (p) {
        this.header = p.title;
        this.project = p;
      }
      const bid = params.get('bid');
      if (bid) {
        this.bid = BookIdentifier.fromString(bid);
      }
    });
  }

}
